export const paymentStatusMap = {
  C: { label: 'Pendiente', color: 'warning' }, // Pending
  S: { label: 'Pago Parcial', color: 'info' }, // Partial
  P: { label: 'Pagado', color: 'success' }, // Paid
  F: { label: 'Fallido', color: 'error' }, // Failed
  I: { label: 'Invitado', color: 'default' }, // Guest
};
